export default __webpack_public_path__ + "static/media/close.07c7dd19.svg";